import moment from 'moment'

import { format, formatDateTime } from '@cbgms/base/utils/datetime'

import { isDateNullValue } from './utils'

interface Props {
  children: string
}

export function LocalizedDateTime(props: Props) {
  const parsedValue = moment(props.children)

  if (isDateNullValue(parsedValue)) return null

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{parsedValue.isValid() ? formatDateTime(parsedValue, format.fullDateTime) : props.children}</>
}
